<template>
    <el-dialog :visible.sync="outerVisible" append-to-body fullscreen :show-close="false">
        <div slot="title" style="display: flex;align-items: center;padding:0 16px;">
            <div style="flex: 1;display: flex;align-items: center;">
                <div style="font-size: 14px;color: #0F1A3A;  opacity: 0.5;">{{ $t('行程统计.page_title') }}</div>
                <img :src="imgIcArrowRight" style="width: 24px;height: 24px;" />
                <div style="font-size: 14px;color: #0F1A3A;">{{ $t('行程统计.行程详情') }}</div>

            </div>
            <el-button type="primary" size="mini" @click="outerVisible = false">{{ $t('driver.返回') }}</el-button>
        </div>
        <div style="overflow: auto;height: 100%;">
            <div style="padding: 20px;background: #FFFFFF;border-radius: 2px;border: 1px solid #D9E4F8;">
                <div style="font-weight: bold;font-size: 14px;color: #0F1A3A;margin-bottom: 20px;">{{ $t('行程统计.行程信息') }}
                </div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div
                            style="background: #E8F0FF;border-radius: 4px;border: 1px solid #D9E4F8;height: 128px;display: flex;flex-direction: column;justify-content: center;padding-left: 28px;">
                            <el-row>
                                <el-col :span="8">
                                    <div style="font-size: 12px;color: #0E193B;">{{ $t('行程统计.车牌号') }}</div>
                                    <div style="font-size: 16px;color: #0E193B;;margin-top: 8px;font-weight: bold;">
                                        {{ VehicleData.CarNo }}
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <div style="font-size: 12px;color: #0E193B;">{{ $t('行程统计.车型') }}</div>
                                    <div style="font-size: 16px;color: #0E193B;;margin-top: 8px;font-weight: bold;">
                                        {{ VehicleData.VehicleModel }}</div>

                                </el-col>
                                <el-col :span="8">
                                    <div style="font-size: 12px;color: #0E193B;">VIN</div>
                                    <div style="font-size: 16px;color: #0E193B;;margin-top: 8px;font-weight: bold;">
                                        {{ VehicleData.VINCode }}</div>
                                </el-col>
                            </el-row>
                        </div>
                        <div
                            style="margin-top: 20px;padding:28px;background: #FFFFFF;border-radius: 2px;border: 1px solid #D9E4F8;">
                            <el-row>
                                <el-col :span="12">
                                    <div style="display: flex;flex-direction: row;align-items: center;">
                                        <img :src="imgIcStart" alt="" style="width: 24px;height: 24px;">
                                        <el-divider></el-divider>
                                    </div>
                                    <div style="margin-top: 20px;">
                                        <div style="font-size: 12px;color: #0E193B;">{{ $t('行程统计.起始时间') }}</div>
                                        <div style="font-weight: bold;font-size: 14px;color: #0E193B;margin-top: 5px;">
                                            {{ VehicleData.BeginTime }}</div>
                                    </div>
                                    <div style="margin-top: 20px;">
                                        <div style="font-size: 12px;color: #0E193B;">{{ $t('行程统计.开始累计里程') }}</div>
                                        <div style="font-weight: bold;font-size: 14px;color: #0E193B;margin-top: 5px;">
                                            {{ VehicleData.BMileage }}</div>
                                    </div>
                                    <div style="margin-top: 20px;">
                                        <div style="font-size: 12px;color: #0E193B;">{{ $t('行程统计.起始位置') }}</div>
                                        <div style="font-weight: bold;font-size: 14px;color: #0E193B;margin-top: 5px;">
                                            {{ VehicleData.BeginPosition }}</div>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div style="display: flex;flex-direction: row;align-items: center;"> <img
                                            :src="imgIcEnd" alt="" style="width: 24px;height: 24px;">
                                    </div>
                                    <div style="margin-top: 20px;">
                                        <div style="font-size: 12px;color: #0E193B;">{{ $t('行程统计.结束时间') }}</div>
                                        <div style="font-weight: bold;font-size: 14px;color: #0E193B;margin-top: 5px;">
                                            {{ VehicleData.EndTime }}</div>
                                    </div>
                                    <div style="margin-top: 20px;">
                                        <div style="font-size: 12px;color: #0E193B;">{{ $t('行程统计.结束累计里程') }}</div>
                                        <div style="font-weight: bold;font-size: 14px;color: #0E193B;margin-top: 5px;">
                                            {{ VehicleData.EMileage }}</div>
                                    </div>
                                    <div style="margin-top: 20px;">
                                        <div style="font-size: 12px;color: #0E193B;">{{ $t('行程统计.结束位置') }}</div>
                                        <div style="font-weight: bold;font-size: 14px;color: #0E193B;margin-top: 5px;">
                                            {{ VehicleData.EndPosition }}</div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <el-row :gutter="20">

                            <el-col class="data_item" :span="8" v-for="(value, index) in source" :key="index">
                                <data_item :title="value.title" :value="value.value"></data_item>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>

            </div>
            <div style="margin-top: 20px;">
                <el-row :gutter="20" style="display: flex;">
                    <el-col :span="12" style="flex: 1;">
                        <div
                            style="padding: 20px;background: #FFFFFF;border-radius: 2px;border: 1px solid #D9E4F8;height: 100%;display: flex;flex-direction: column;">
                            <div style="font-size: 14px;color: #0F1A3A;font-weight: bold;">{{ $t('行程统计.事件信息') }}</div>
                            <div style="margin-top: 20px;display: flex;flex-direction: column;flex: 1;">
                                <el-table v-loading="loading" :data="tableData" border
                                    style="width: 100%; margin-bottom: 16px;flex: 1;">
                                    <!-- 序号列（自动从1开始） -->
                                    <el-table-column type="index" :label="$t('行程统计.序号')"
                                        align="center"></el-table-column>
                                    <!-- 发生时间 -->
                                    <el-table-column prop="GpsDateTime" :label="$t('行程统计.事件时间')" align="center">
                                        <template slot-scope="scope">
                                            {{ formatDate(scope.row.GpsDateTime) }}
                                        </template>
                                    </el-table-column>

                                    <!-- 事件名称 -->
                                    <el-table-column prop="BadDrivingName" :label="$t('行程统计.事件名称')"
                                        align="center"></el-table-column>
                                    <!-- 发生位置 -->
                                    <el-table-column prop="Position" :label="$t('行程统计.发生位置')"
                                        align="center"></el-table-column>
                                </el-table>
                                <div>
                                    <kl-pagination :total="total" @current-change="pageChange"
                                        :current-page.sync="form.PageNo">
                                    </kl-pagination>
                                </div>
                            </div>

                        </div>
                    </el-col>
                    <el-col :span="12" style="flex: 1;">

                        <div style="padding: 20px;background: #FFFFFF;border-radius: 2px;border: 1px solid #D9E4F8;">

                            <travel_trajectory_map ref="trajectoryMap" />

                        </div>
                    </el-col>
                </el-row>

            </div>
            <div style="margin-top: 20px;" v-if="false">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div style="padding: 20px;background: #FFFFFF;border-radius: 2px;border: 1px solid #D9E4F8;">
                            <div style="display: flex;align-items: center;">
                                <div style="font-size: 14px;color: #0F1A3A;font-weight: bold;">{{ $t('行程统计.速度分析') }}
                                </div>
                                <div style="font-size: 12px;color: #0F1A3A;line-height: 14px;margin-left: 32px;">
                                    {{ $t('行程统计.最高速度') }}66km/h {{ $t('行程统计.最大电机转速') }}2849r/min
                                </div>
                            </div>
                            <div>
                                <chart_item />
                            </div>

                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div style="padding: 20px;background: #FFFFFF;border-radius: 2px;border: 1px solid #D9E4F8;">

                            <div style="display: flex;align-items: center;">
                                <div style="font-size: 14px;color: #0F1A3A;font-weight: bold;">{{ $t('行程统计.踏板分析') }}
                                </div>
                                <div style="font-size: 12px;color: #0F1A3A;line-height: 14px;margin-left: 32px;">
                                    {{ $t('行程统计.最大油门踏板') }} 100% {{ $t('行程统计.最大刹车踏板') }}36%
                                </div>
                            </div>
                            <div>
                                <chart_item />
                            </div>
                        </div>
                    </el-col>
                </el-row>


            </div>
        </div>

    </el-dialog>
</template>
<script>
import chart_item from './components/chart_item.vue'
import track_data_item from './components/track_data_item.vue'
import data_item from './components/data_item.vue'
import travel_trajectory_map from './components/travel_trajectory_map.vue'

import { formatTime } from "@/utils/longyi";
import { queryWebDigitalRecDetail } from '@/http/vehicle'
import imgIcArrowRight from "@/assets/images/ic_arrow_right.png";
import imgIcStart from "@/assets/images/ic_start.png";
import imgIcEnd from "@/assets/images/ic_end.png";


export default {
    components: {
        data_item,
        track_data_item, chart_item, travel_trajectory_map

    },
    data() {
        return {
            imgIcArrowRight,
            imgIcStart,
            imgIcEnd,
            outerVisible: false,
            loading: false,


            form: {
                VID: '',
                BeginTime: '',
                EndTime: '',
                OilType: '',// 1电车 2油车


                PageNo: 1,
                PageSize: 10
            },

            total: 0,
            tableData: [

            ],
            source: [
                {
                    title: this.$t('行程统计.距离(km)'),
                    value: '-'
                },
                {
                    title: this.$t('行程统计.平均时速(km/h)'),
                    value: '-'
                },
                {
                    title: this.$t('行程统计.开始能量余量(%)'),
                    value: '-'
                },
                {
                    title: this.$t('行程统计.时间(h)'),
                    value: '-'
                },
                {
                    title: this.$t('行程统计.最高速度(km/h)'),
                    value: '-'
                },
                {
                    title: this.$t('行程统计.结束能量余量(%)'),
                    value: '-'
                },
                {
                    title: this.$t('行程统计.总能耗(kW·h)'),
                    value: '-'
                },
                {
                    title: this.$t('行程统计.平均百公里能耗(kW·h/100km)'),
                    value: '-'
                },
                {
                    title: this.$t('行程统计.能源消耗量(%)'),
                    value: '-'
                },
                // {
                //     title: this.$t('行程统计.总回收能耗(kW·h)'),
                //     value: '-'
                // },
                // {
                //     title: this.$t('行程统计.驱动能耗(kW·h)'),
                //     value: '-'
                // },
                // {
                //     title: this.$t('行程统计.除霜器(kW·h)'),
                //     value: ''
                // },
                // {
                //     title: this.$t('行程统计.空调(kW·h)'),
                //     value: '-'
                // },
                // {
                //     title: this.$t('行程统计.电加热(kW·h)'),
                //     value: '-'
                // },
                // {
                //     title: this.$t('行程统计.转向机(kW·h)'),
                //     value: '-'
                // },
                // {
                //     title: this.$t('行程统计.空压机(kW·h)'),
                //     value: '-'
                // },
                // {
                //     title: this.$t('行程统计.DCDC(kW·h)'),
                //     value: '-'
                // },
            ],
            VehicleData: {},
            TraceData: {},
        }
    },
    mounted() {
        // this.queryDetail()
    },

    methods: {
        formatDate(date) {
            if (!date) {
                return ''
            }
            return date.replace('T', ' ').replace('Z', '').replace(/-/g, '/')
        },
        getOperatorID() {
            // return "1665";
            // return "7544";
            return this.$store.getters.operatorID;
        },
        show(VID, BeginTime, EndTime, OilType) {

            this.outerVisible = true;
            this.form.VID = VID;
            this.form.BeginTime = BeginTime;
            this.form.EndTime = EndTime;
            this.form.OilType = OilType;// 1电车 2油车

            this.queryDetail()


        },
        queryDetail() {
            //查询行程详情和轨迹列表
            queryWebDigitalRecDetail({
                "OperatorID": this.getOperatorID(),
                "VehicleIDs": this.form.VID.toString(),

                "BeginTime": this.form.BeginTime,
                "EndTime": this.form.EndTime,
                "Flag": 3,
                "OilType": this.form.OilType,

                "PageNo": this.form.PageNo,
                "PageSize": this.form.PageSize

            }).then(res => {

                if (res && res.code == 200) {
                    this.VehicleData = res.tripDetail.VehicleData
                    this.VehicleData.BeginTime = formatTime(this.VehicleData.BeginTime)
                    this.VehicleData.EndTime = formatTime(this.VehicleData.EndTime)


                    this.TraceData = res.tripDetail.TraceData
                    this.$nextTick(() => {
                        this.$refs.trajectoryMap.showData(this.TraceData, this.VehicleData.CarNo)

                    })
                    var more_data = [];
                    more_data.push({
                        title: this.$t('行程统计.距离(km)'),
                        value: this.VehicleData.Mileage
                    })
                    more_data.push({
                        title: this.$t('行程统计.平均时速(km/h)'),
                        value: this.VehicleData.AvgSpeed
                    })
                    if (this.form.OilType == 1) {
                        more_data.push({
                            title: this.$t('行程统计.开始能量余量(%)'),
                            value: this.VehicleData.BeginSoc
                        })
                    }
                    more_data.push({
                        title: this.$t('行程统计.时间(h)'),
                        value: this.VehicleData.RunDuration
                    })
                    more_data.push({
                        title: this.$t('行程统计.最高速度(km/h)'),
                        value: this.VehicleData.MaxSpeed
                    })
                    if (this.form.OilType == 1) {
                        more_data.push({
                            title: this.$t('行程统计.结束能量余量(%)'),
                            value: this.VehicleData.EndSoc
                        })
                    }
                    //总能耗，油车要区别
                    if (this.form.OilType == 1) {
                        more_data.push({
                            title: this.$t('行程统计.总能耗(kW·h)'),
                            value: this.VehicleData.Consume
                        })
                        more_data.push({
                            title: this.$t('行程统计.平均百公里能耗(kW·h/100km)'),
                            value: this.VehicleData.AvgConsume
                        })
                    }
                    else {
                        more_data.push({
                            title: this.$t('行程统计.总能耗(L)'),
                            value: this.VehicleData.Consume
                        })
                        more_data.push({
                            title: this.$t('行程统计.平均百公里能耗(L/100km)'),
                            value: this.VehicleData.AvgConsume
                        })
                    }

                    if (this.form.OilType == 1) {
                        more_data.push({
                            title: this.$t('行程统计.能源消耗量(%)'),
                            value: this.VehicleData.SocConsume
                        })
                    }
                    if (this.form.OilType == 1) {
                        more_data.push({
                            title: this.$t('行程统计.总回收能耗(kW·h)'),
                            value: this.VehicleData.BrackRecycleEnergy
                        })
                        more_data.push({
                            title: this.$t('行程统计.驱动能耗(kW·h)'),
                            value: this.VehicleData.BrackRecycleEnergy
                        })
                        // more_data.push({
                        //     title: this.$t('行程统计.除霜器(kW·h)'),
                        //     value: '12.86'
                        // })
                        more_data.push({
                            title: this.$t('行程统计.空调(kW·h)'),
                            value: this.VehicleData.AirConditionElecQuantity
                        })
                        more_data.push({
                            title: this.$t('行程统计.电加热(kW·h)'),
                            value: this.VehicleData.PTCQuantity
                        })
                        more_data.push({
                            title: this.$t('行程统计.转向机(kW·h)'),
                            value: this.VehicleData.SteeringOilPumpElecQuantity
                        })
                        more_data.push({
                            title: this.$t('行程统计.空压机(kW·h)'),
                            value: this.VehicleData.BlastPumpElecQuantity
                        })
                        more_data.push({
                            title: this.$t('行程统计.DCDC(kW·h)'),
                            value: this.VehicleData.DCConsumeEnergy
                        })
                    }

                    this.source = more_data;
                }
            })

            //查询不良驾驶数据 badDrivings
            this.queryBadDriving()
        },
        queryBadDriving() {
            this.loading = true;

            queryWebDigitalRecDetail({
                "OperatorID": this.getOperatorID(),
                "VehicleIDs": this.form.VID.toString(),
                "BeginTime": this.form.BeginTime,
                "EndTime": this.form.EndTime,
                "Flag": 4,
                "PageNo": this.form.PageNo,
                "PageSize": this.form.PageSize

            }).then(res => {
                this.loading = false;

                if (res && res.code == 200) {
                    this.tableData = res.badDrivings
                    this.total = res.badDrivingsCount

                }
            })
        },

        onClose() {
            this.$emit('onClose');
        },

        pageChange(page) {
            this.form.PageNo = page;
            this.queryBadDriving();

        }
    }
}
</script>

<style>
.pagination-bar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /* 左对齐，与示例一致 */
    gap: 10px;

}
</style>